module.exports = __webpack_public_path__ + "img/i-logout-mono.c672f240.svg";